import { render } from "./applications.vue?vue&type=template&id=67319e18&scoped=true"
import script from "./applications.vue?vue&type=script&lang=js"
export * from "./applications.vue?vue&type=script&lang=js"

import "./applications.vue?vue&type=style&index=0&id=67319e18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67319e18"]])

export default __exports__